import { Directive } from "@angular/core";

@Directive({
    selector: "[ifmRedirect]",
    standalone: false
})
export class RedirectDirective {
  constructor() {}

}
